export const NuxtApollo = {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge": 604800, "secure": true, "sameSite": "lax"},
 clients: {"default": {"httpEndpoint": "https://www.waitmate.org.au/_payload/graphql", "inMemoryCacheOptions": {"possibleTypes": {"Link_Url": ["ExternalUrlBlock", "InternalUrlBlock"], "PayloadPreference_User": ["Staff"]}}, "connectToDevTools": false, "authType": "Bearer", "authHeader": "Authorization", "tokenName": "apollo:default.token", "tokenStorage": "cookie", "defaultOptions": undefined}}
}